// Real client testimonials. Edit/append here.

export const TESTIMONIALS = [
  {
    id: "nicole-2025",
    date: "February 26, 2025",
    name: "Nicole",
    location: "Boswell Meadows, Fort Worth, TX",
    transaction: "Bought a Single Family home in 2024",
    quote: "Torey answered all the questions we had (including the 1000 questions for a person who had never done this before) and helped us negotiate a fair price for the home we bought. He was always a text away and responded quickly. If you need a place in DFW, I highly recommend Torey!",
    rating: 5,
  },
  {
    id: "zachary-2023",
    date: "August 2, 2023",
    name: "Zachary Posekany",
    location: "Southeast, Arlington, TX",
    transaction: "Bought a Single Family home in 2023",
    quote: "Not enough can be said about the experience we had with Mr. Irving. Going into a situation where my wife and I knew we were about to make the biggest investment of our life, this man made it feel like a cakewalk. Not once did I feel confused, unsure, or behind on anything during our home-buying process. Not only was Torey's communication punctual and articulate; it was friendly and relatable. It quickly became evident how knowledgeable Torey is, and how much pride he takes in his profession.",
    rating: 5,
  },
  {
    id: "drmokat-2023",
    date: "May 20, 2023",
    name: "drmokat",
    location: "Heather Ridge Estates, Saginaw, TX",
    transaction: "Bought a Single Family home in 2023",
    quote: "Torey was, and is, amazing. he was very timely with his information and was very good at showing us what we wanted. Our process was very smooth; Torey knew the answers to all our questions, so there were no surprises. I highly recommend Torey. I've already referred people to him!",
    rating: 5,
  },
];
